import { FormGrid } from "components/UI/Form/FormGrid";
import {useGeneralForm} from "components/UI/GeneralForm/hooks/useGeneralForm";
import {
    FormStructureSelectSearchable
} from "components/UI/Selects/FormStructureSelectSearchable/FormStructureSelectSearchable.tsx";
import {usePaldockTranslation} from "hooks/usePaldockTranslation";
import {FormItem} from "react-hook-form-antd";
import {FormStructureType} from "types/enums";

import {OfferApiFormEditFormData} from "../formSchema";


export const ApiFormStructureSection = () => {
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const { control, fieldNames } = useGeneralForm<OfferApiFormEditFormData>();

    return (
        <FormGrid cols={1}>
            <FormItem control={control} name={fieldNames.form_structures.name} label={tFields("form_structure.label")}>
               <FormStructureSelectSearchable filter={{ filter: { type: FormStructureType.Lead } }} mode={"multiple"} allowClear={true} />
            </FormItem>
        </FormGrid>
    );
};
